
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
    Table,
} from "reactstrap";

import Api from "services/api"
// import AddInviteInterpreter from "components/inviteInterpreter/AddInviteInterpreter";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { SearchBar } from "components/common/SearchBar";
import { removeMultipleInviteInterpreter } from "slices/inviteInterpreterSlice";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { SortButtons } from "components/common/SortButtons";
import { fetchInviteInterpreters } from "slices/inviteInterpreterSlice";
// import { otherInviteInterpreterSelector } from "slices/otherInviteInterpreterSlice";
// import { fetchOtherInviteInterpreters } from "slices/otherInviteInterpreterSlice";
import { addInviteInterpreter } from "slices/inviteInterpreterSlice";
import { removeInviteInterpreter } from "slices/inviteInterpreterSlice";
import FullPageLoader from "components/common/FullPageLoader";
import { inviteInterpretersSelector } from "slices/inviteInterpreterSlice";
import { fetchAppointmentsInterpreters } from "slices/inviteInterpreterSlice";
import { addInviteInterpreters } from "slices/inviteInterpreterSlice";
import InterpretersWithAppointments from "./InterpretersWithAppointments";
import AppointedInterpretersList from "./AppointedInterpretersList";
import Swal from "sweetalert2";
import { fetchAppointmentView } from "slices/inviteInterpreterSlice";
import { appointmentsSelector } from "slices/appointmentSlice";
import { fetchInvitedInterpreters } from "slices/inviteInterpreterSlice";


const apiService = new Api();
function InviteInterpreterList({ itemId, appointmentData , isModal = false}) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showInvitedList, setInvitedList] = useState(false);
    const fetchingList = async () => {
        setLoading(true)
        await dispatch(fetchAppointmentsInterpreters(itemId))
        await dispatch(fetchAppointmentView(itemId))
        setLoading(false)
    }
    React.useEffect(() => {
        fetchingList()
    }, [])


    const handleInvitedList = React.useCallback(() => {
        setInvitedList(true);
        // scroll to this div interperters-with-appt

    }, [showInvitedList])

    useEffect(() => {
        if (showInvitedList) {
            const element = document.getElementById("interperters-with-appt");
            element.scrollIntoView({ behavior: "smooth" });
        }
    }, [showInvitedList])


    return (
        <>
            <InviteInterpreters height={'height-auto'} itemId={itemId} appointmentData={appointmentData} mainLoader={loading} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} isModal={isModal} />
            <AppointedInterpretersList height={'height-auto'} itemId={itemId} appointmentData={appointmentData} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} />



            {showInvitedList && <InterpretersWithAppointments height={'height-auto'} itemId={itemId} showInvitedList={showInvitedList} />}

            <div id="interperters-with-appt">   </div>

            <div className={isModal && 'inviteModalLoader'}>
            {loading && <FullPageLoader />}
            </div>
        </>

    )
}

const InviteInterpreterItem = ({
    item, index, selectedItems, handleChange, handleAddPopUp
}) => {
    const dispatch = useDispatch();

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.id} checked={selectedItems?.includes(item?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            {/* <td>
                <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.id}`}>
                    {item?.code}
                </a>
            </td> */}
            <td>
                <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.id}`}>
                {item?.first_name + " " + item?.last_name}
                </a>
            </td>
            <td>
                {item?.user?.email}
            </td>
            <td>
                {item?.phone}
            </td>
            <td>
                {item?.languages?.map(l => l?.language?.name + ", ")}
            </td>

        </tr>
    )
}

const InviteInterpreters = ({ mainLoader, handleInvitedList, invitedList, itemId, appointmentData, height, isModal }) => {
    console.log('isssmodal',isModal);
    const dispatch = useDispatch()
    const { inviteInterpreters, last_page: totalPages, loader, allInterpreters } = useSelector(inviteInterpretersSelector);

    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}

    });
    const navigate = useNavigate()
    const refAddutton = React.useRef(null);

    // useEffect(() => {

    //     if (
    //         appointmentData &&
    //         appointmentData?.status !== 'available'
    //     ) {

    //         toast.error('This appointment is no longer available.');

    //         navigate(-1);

    //     }

    // }, [appointmentData]);
    
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });

    const handlePageChange = React.useCallback((page) => {
        setCurrentPage(page);
        dispatch(fetchInviteInterpreters(page));
    }, [])
    const handleAddInviteInterpreterPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const handleSubmitInviteInterpreters = React.useCallback(() => {
        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                // dispatch(fetchInviteInterpreters())
                dispatch(fetchInvitedInterpreters(itemId))
                dispatch(fetchAppointmentView(itemId))

                //   dispatch(fetchOtherInviteInterpreters())
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };
        new Swal({
            title: "Are you sure?",
            text: "You want to invite these vendors?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#075665",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(addInviteInterpreters({ interpreter_ids: selectedItems, }, itemId, submitCallback))
            }
        })
    }, [selectedItems, itemId])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(allInterpreters.map((inviteInterpreter) => inviteInterpreter.id.toString()))
    }, [selectedItems, selectAll, allInterpreters])



    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                {/* <th className="col-1">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Code</p>
                    </div>
                </th> */}
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Phone</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th>

            </tr>
        )
    }, [selectedItems, allInterpreters])


    const renderTableContent = React.useCallback(() => {

        return (
            allInterpreters?.map((item, index) => {
                return <InviteInterpreterItem item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteInterpreterPopUp} />
            })
        )
    }, [allInterpreters, selectedItems]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    const renderFooter = React.useCallback(() => {
        return (
            <div className="row-primary">

                <button
                    onClick={handleSubmitInviteInterpreters}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Invite Vendors
                </button>

                {/* <button
                    onClick={handleInvitedList}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Interpreters with Appointment
                </button> */}
            </div>
        )
    }, [selectedItems, invitedList, handleInvitedList])
    return (
        <>
            <ListLayout
                // heading={`Invite Interpreter (${appointmentData?.appid})`}
                heading={
                            isModal
                                ? null
                                : `Invite Vendor (${appointmentData?.appid})`
                        }
                time={false}
                height={height}
                title="Vendors"
                addButtonDisabled={true}
                buttonTitle="Add InviteVendor"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchInviteInterpreters}
                selectedItems={selectedItems}
                // handleRemoveItems={handleRemoveItems}
                // renderAddForm={<AddInviteInterpreter item={addForm.item} show={addForm.show} onClose={handleClose} />}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddInviteInterpreterPopUp}
                renderFooter={renderFooter}
                hideRemoveButton={true}
                // loader={mainLoader}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                // haveBackBtn={true}
                haveBackBtn={!isModal}
                // onBackButtonClick={
                //     () => navigate(`/appointments/view/${appointmentData?.id}`)
                // }
                onBackButtonClick={
                    isModal ? undefined : () => navigate(`/appointments/view/${appointmentData?.id}`)
                }
            >
            </ListLayout>
        </>
    )

}

export default InviteInterpreterList;
